/** Edit one record of a master. */

import { useParams } from "react-router-dom";

import { Crumbs, PageHead, Problem } from "@/components/kit";
import { RecordFormClient } from "@/components/masters/RecordFormClient";
import { ApiError, getRecord } from "@/lib/api/client";
import { displayName } from "@/lib/format";
import { loadMaster, loadRelatedRows } from "@/lib/masters/load";
import { useApi } from "@/spa/useApi";

export function EditRecordPage() {
  const {
    sport = "",
    master: masterCode = "",
    code = "",
  } = useParams<{ sport: string; master: string; code: string }>();

  const { data, loading, error, cause } = useApi(
    async () => {
      const master = await loadMaster(sport, masterCode);
      const [related, record] = await Promise.all([
        loadRelatedRows(sport, master),
        getRecord(sport, masterCode, code),
      ]);
      return { master, related, record };
    },
    [sport, masterCode, code],
    "failed to load",
  );

  if (error) {
    if (cause instanceof ApiError && cause.status === 404) {
      return <Problem>Record not found.</Problem>;
    }
    return <Problem>Could not load record: {error}</Problem>;
  }
  if (!data) return <PageHead title={code} note={loading ? "Loading…" : ""} />;

  const { master, related, record } = data;
  return (
    <>
      <Crumbs
        trail={[
          { label: "Sports", href: "/sports" },
          { label: displayName(sport), href: `/${sport}` },
          { label: master.label, href: `/${sport}/masters/${masterCode}` },
          { label: record.name },
        ]}
      />
      <PageHead title={record.name} note={`${master.label} · ${record.code}`} />
      <RecordFormClient sport={sport} master={master} related={related} record={record} />
    </>
  );
}
